import template from "./index.html";
import "./index.less";
import { REPORT_STATES } from "constants.js";
import moment from "moment";
import { hasHadState } from "../../utils";

function controller(appState, $userProfile, $logger) {
	const ctrl = this;

	ctrl.handleToggleIsExpanded = handleToggleIsExpanded;
	ctrl.canBeDeleted = canBeDeleted;
	ctrl.canBeWithdrawn = canBeWithdrawn;
	ctrl.hasBeenSubmitted = (report) => hasHadState(REPORT_STATES.submitted.code, report);
	ctrl.reportStates = REPORT_STATES;
	ctrl.canBeRestored = canBeRestored;
	ctrl.getFormattedTime = getFormattedTime;
	ctrl.getFullDate = getFullDate;
	ctrl.userProfile = $userProfile;
	ctrl.getLastSubmittedDate = getLastSubmittedDate;

	ctrl.$onInit = () => {
		ctrl.permissions = appState.permissions;
		ctrl.form = appState.forms.selected;
		ctrl.canAmend = appState.permissions.Reporting.Actions.CanAmend;

		ctrl.canWithdraw = false;
		ctrl.canDelete = false;
		ctrl.canRestore = false;
		ctrl.isExpanded = false;

		if(!ctrl.permissions.Reporting.IsDisabled) {
			canBeWithdrawn();
			canBeDeleted();
			canBeRestored();
		}
	};

	ctrl.withdraw = () => {
		$logger.event($logger.buildReportEvent("withdraw")("requested"), { 
			via: "action-info-block"  
		});
		ctrl.handleWithdraw();
	};

	ctrl.delete = () => {
		$logger.event($logger.buildReportEvent("delete")("requested"), { 
			via: "action-info-block"  
		});
		ctrl.handleDelete();
	};

	ctrl.restore = () => {
		$logger.event($logger.buildReportEvent("restore")("requested"), { 
			via: "action-info-block"  
		});
		ctrl.handleRestore();
	};

	function canBeDeleted() {
		ctrl.canDelete = ctrl.permissions.Reporting.Actions.CanDelete && !ctrl.report.Submitted && !ctrl.report.IsDeleted;

		return ctrl.canDelete;
	}

	function canBeWithdrawn() {
		ctrl.canWithdraw = ctrl.permissions.Reporting.Actions.CanWithdraw && ctrl.report.Submitted && !ctrl.report.IsDeleted;

		return ctrl.canWithdraw;
	}

	function handleToggleIsExpanded() {
		ctrl.isExpanded = !ctrl.isExpanded;
	}

	function canBeRestored() {
		ctrl.canRestore = ctrl.permissions.Reporting.Actions.CanRestore && !ctrl.report.Submitted && ctrl.report.IsDeleted;

		return ctrl.canRestore;
	}

	function getFormattedTime(timeToModify) {
		return moment(ctrl.report[timeToModify])
			.local()
			.fromNow();
	}

	function getLastSubmittedDate() {
		const historyCopy = [...(ctrl.report.History ?? [])]
			.sort((a, b) => moment(a.Occurred).isBefore(b.Occurred) ? 1 : -1);

		const lastEntry = historyCopy.find(i => i.State.Code === REPORT_STATES.submitted.code);
		if(lastEntry && lastEntry.Occurred) {
			return formatDate(lastEntry.Occurred);
		} else {
			return "";
		}
	}

	function getFullDate(time) {
		if(!!ctrl.report[time]) {
			return formatDate(ctrl.report[time]);
		}
		return "--";
	}

	function formatDate(date) {
		return moment(date)
			.local()
			.format(`dddd, MMMM Do YYYY, ${ctrl.userProfile.getUserProfile().timeDisplay === "24h" ? "HH" : "hh"}:mm a`)
			.toString();
	}
}

export default angular.module("vesl.components.action-info-block", []).component("actionInfoBlock", {
	template,
	controller,
	bindings: {
		report: "<",
		handleDelete: "<",
		handleWithdraw: "<",
		handleRestore: "<"
	}
}).name;
